import { BRAND } from "@/lib/brand";

/**
 * Brand wordmark. `tone` controls the color treatment:
 *   - "ink"    (default) — deep emerald ink for ivory backgrounds
 *   - "ivory"            — off-white for dark spotlight areas
 */
export const BrandLogo = ({
  className = "h-10",
  testId = "brand-logo",
  tone = "ink",
}) => {
  const filter =
    tone === "ivory"
      ? "brightness(0) invert(1) opacity(0.96)"
      : "brightness(0) opacity(0.9)";
  return (
    <div
      data-testid={testId}
      className={`relative inline-block overflow-hidden ${className}`}
      style={{ aspectRatio: "4.6 / 1" }}
      aria-label="Delhigence.AI"
      role="img"
    >
      <img
        src={BRAND.logo}
        alt="Delhigence.AI"
        className="pointer-events-none absolute left-1/2 top-1/2 max-w-none -translate-x-1/2 -translate-y-1/2 select-none"
        style={{ height: "560%", filter }}
        draggable={false}
      />
    </div>
  );
};
